"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* tslint:disable */

var react_1 = __importDefault(require("react"));

var SvgUserBan = function SvgUserBan(props) {
  return react_1.default.createElement("svg", __assign({
    width: '1em',
    height: '1em',
    viewBox: '0 0 24 24'
  }, props), react_1.default.createElement("path", {
    d: 'M15 6.814C15 5.515 13.782 4 12 4S9.004 5.462 9.004 7c0 1.553 1.23 2.994 2.998 2.994l.24.006-1.7 1.784a5 5 0 1 1 6.102-6.641L15 6.813zM2 19.785C2 15.047 5.331 14 7.776 14.002 7.776 14 2 19.785 2 19.785zM20.002 20c0-2.667-1.333-4-4-4h-1.745a611.359 611.359 0 0 1 2.029-1.997C20.096 14.001 22 16 22 20c0 1.333-.667 2-2 2H8.283l2.001-2h9.718zM18.207 6.367c.463-.48.935-.48 1.414 0 .48.48.48.951 0 1.415l-13.9 13.9c-.46.481-.931.481-1.414 0-.482-.483-.482-.954 0-1.415l13.9-13.9z'
  }));
};

exports.default = SvgUserBan;